import { render, staticRenderFns } from "./UpgradeCard.vue?vue&type=template&id=e21b9954&scoped=true&"
import script from "./UpgradeCard.vue?vue&type=script&lang=js&"
export * from "./UpgradeCard.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeCard.vue?vue&type=style&index=0&id=e21b9954&prod&lang=css&"
import style1 from "./UpgradeCard.vue?vue&type=style&index=1&id=e21b9954&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21b9954",
  null
  
)

export default component.exports